"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _postal = _interopRequireDefault(require("@mtt/postal"));

require("@mtt/postal.federation");

require("@mtt/postal.xframe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_postal.default.configuration.DEFAULT_CHANNEL = "mtt.client";

_postal.default.fedx.configure({
  filterMode: "whitelist"
});

_postal.default.fedx.addFilter([{
  channel: "mtt.client",
  topic: "#",
  direction: "both"
}]);

var _default = _postal.default;
exports.default = _default;